import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeatsState } from '../../application/states/seats.state';
import { ThemeService } from '../theme/theme.service';
import { TranslocoModule } from '@ngneat/transloco';
import { map } from 'rxjs';

import { SEAT_PERSON_ICON_PATH, SEAT_PERSON_ICON_SIZE } from '../seat-person-icon';

@Component({
  selector: 'plys-seats-legenda',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './seats-legenda.component.html',
  styleUrls: ['./seats-legenda.component.scss'],
})
export class SeatsLegendaComponent {
  types$ = this.seatsState.types$;
  configColors$ = this.types$.pipe(map((types) => types.find((type) => type.isDefault)));
  theme$ = this.themeService.theme$;

  readonly personIconPath = SEAT_PERSON_ICON_PATH;
  readonly personIconViewBox = `0 0 ${SEAT_PERSON_ICON_SIZE} ${SEAT_PERSON_ICON_SIZE}`;

  constructor(private seatsState: SeatsState, private themeService: ThemeService) {}
}
